import { useState, useEffect } from "react";
import "./index.css";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import GeoMapLeaflet from "../../../components/_utils/GeoMapLeaflet";

import { getOwnerAccountIFSCDetails } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import Loader from "../../../components/Loader/Index";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import CommonToast from "../../../components/_utils/CommonToast";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import CommonContainerCard from "../../../components/_utils/CommonContainerCard";
import TEXT from "../../../utils/globalText";
import ICONS from "../../../assets/Icons";

const IFSCDetails = ({ ifsc_code, popup }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const [ownerDetailIfscData, setOwnerdetailIfscdata] = useState([]);

  useEffect(() => {
    async function fetchIFSCData() {
      setLoading(true);
      try {
        const response = await dispatch(
          getOwnerAccountIFSCDetails({ search_string: popup ? ifsc_code : id }),
        );
        if (
          response?.payload?.message === "Request failed with status code 404"
        ) {
          navigate(GlobalConfiguration?.navigate_back);
          CommonToast({
            text:
              response?.payload?.response?.data?.errors?.base?.[0] ||
              "An unknown error occured",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        setOwnerdetailIfscdata(response?.payload?.ifsc_details?.[0]);
      } catch (error) {
        console.error("Error", error);
      } finally {
        setLoading(false);
      }
    }

    fetchIFSCData();
  }, [id]);

  const { bank, ifsc, contact, micr, last_updated, address } =
    ownerDetailIfscData ?? {};

  return (
    <>
      <div
        className="flex flex-col h-height-full overflow-x-hidden overflow-auto bg-primary-bg pb-padding-md mt-margin-base "
        id="container"
      >
        <div
          className={`bg-primary-nav shadow-box-shadow-bottom fixed top-top-base left-left-base z-z-index-tooltip w-width-full block ${popup ? "hidden" : "Qsmd:hidden"}`}
        >
          <TopNavComponent
            isFormattingNotRequired={true}
            topNavHeader="IFSC Verification"
            topNavSubText="IFSC details"
          />
        </div>
        {loading ? (
          <div className="flex flex-1 items-center justify-center">
            <Loader />
          </div>
        ) : (
          <>
            <div
              className={`w-auto bg-primary-nav ${
                popup
                  ? ""
                  : "pt-[calc(var(--padding-md)+var(--padding-xl))] Qmd:pt-[var(--navbar-breadcrumb-height)]"
              }`}
            >
              <div className="Qlg:w-max-content-width w-width-full px-mobile-padding-l Qmd:px-padding-base mx-auto">
                <div
                  className={`grid grid-cols-1 Qmd:grid-cols-3 items-center border-b border-primary-bg Qmd:py-padding-md ${popup ? "px-padding-base Qmd:px-padding-md Qlg:px-padding-base" : "px-padding-base Qmd:px-padding-md Qlg:px-padding-base"}`}
                >
                  <div className="border-b Qmd:border-b-border-base Qmd:border-r border-primary-bg flex justify-between items-center py-mobile-padding-l Qmd:py-padding-base">
                    <div className="flex flex-col gap-gap-xs pl-padding-base Qlg:pl-padding-sm">
                      <TitleSubtitlePair title={ifsc} subtitle="IFSC code" />
                    </div>
                    <div className="Qmd:mr-margin-md">
                      <CommonBankLogo ifsc={ifsc} variant="big" type="pill" />
                    </div>
                  </div>

                  <div className="Qmd:col-span-2 flex flex-col gap-gap-xs border-b Qmd:border-b-border-base Qmd:border-r border-transparent lg:px-padding-md Qmd:pl-padding-md sm:px-padding-base Qmd:py-padding-base py-mobile-padding-l">
                    <TitleSubtitlePair title={bank} subtitle="Bank name" />
                  </div>
                </div>

                <div
                  className={`grid grid-cols-1 Qmd:grid-cols-3 items-center pt-mobile-padding-l Qmd:py-padding-md ${popup ? "px-padding-base Qmd:px-padding-md Qlg:px-padding-base" : "px-padding-base Qmd:px-padding-md Qlg:px-padding-base"}`}
                >
                  <div className="border-b Qmd:border-b-border-base Qmd:border-r border-primary-bg pb-mobile-padding-l Qmd:pb-padding-base">
                    <div className="flex pl-padding-base Qlg:pl-padding-sm">
                      <TitleSubtitlePair
                        title={
                          contact
                            ? contact.startsWith("+")
                              ? contact
                              : `+${contact.substring(GlobalConfiguration?.lengthCheckZero, GlobalConfiguration?.lengthCheckTwo)}\u00A0${contact.substring(
                                  GlobalConfiguration?.lengthCheckTwo,
                                )}`
                            : "Not available"
                        }
                        subtitle="Contact number"
                      />
                    </div>
                  </div>

                  <div className=" border-b Qmd:border-b-border-base Qmd:border-r border-primary-bg Qsmd:px-padding-md py-mobile-padding-l Qsmd:py-padding-base">
                    <TitleSubtitlePair
                      title={micr ? micr : "Not available"}
                      subtitle="MICR"
                    />
                  </div>

                  <div className=" Qsmd:pl-padding-md py-mobile-padding-l Qsmd:py-padding-base">
                    <TitleSubtitlePair
                      title={formatDateViewAll(last_updated, true, true)}
                      subtitle="Last updated"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`max-w-tab-width-normal w-width-full mx-auto px-padding-base`}
            >
              <div className="my-margin-md ml-mobile-margin-l Qmd:ml-margin-md Qlg:ml-margin-base">
                <SwitcherTabs
                  tabs={[
                    {
                      label: "Address",
                      key: "Address",
                      handleFunction: () => {},
                    },
                  ]}
                />
              </div>

              <CommonContainerCard header={TEXT?.CORPORATE_ADDRESS}>
                <div className="flex flex-col gap-gap-md md:flex-row Qmd:flex-row items-start justify-between ">
                  <div className="flex flex-col gap-y-gap-xs">
                    <p className="text-text-primary text-font-sm font-normal">
                      {address || "N/A"}
                    </p>
                  </div>

                  {!loading ? (
                    <div className="flex justify-center Qmd:justify-center md:justify-end Qmd:max-w-max-map-leaflet-width w-width-full Qmd:flex-shrink-0 flex-shrink z-z-index-content">
                      <GeoMapLeaflet
                        address={address}
                        owner="cin_details"
                        enableGeocoding={false}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </CommonContainerCard>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default IFSCDetails;
